import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fileUploadService } from "./fileUpload.service";

const initialState = {};

// First, create the thunk
export const uploadFile = createAsyncThunk(
  "files/upload",
  async (data, thunkAPI) => {
    const response = await fileUploadService.create(data, (p) => {
      const percentCompleted = Math.round((p.loaded * 100) / p.total);
      thunkAPI.dispatch(updateProgress({ percentage: percentCompleted }));
    });

    return response.data;
  }
);

export const removeFile = createAsyncThunk(
  "files/remove",
  async (data, thunkAPI) => {
    const response = await fileUploadService.remove(data.fileId);
    return response.data;
  }
);

export const filesSlice = createSlice({
  name: "files",
  initialState,
  reducers: {
    updateProgress: (state, action) => {
      state.file = { loading: true, progress: action.payload.percentage };
    },
    selectFiles: (state, action) => {
      state.uploadedFiles = action.payload;
    },
    resetFiles: (state) => {
      state.uploadedFiles = {};
    },
  },
  extraReducers: {
    [uploadFile.fulfilled]: (state, action) => {
      state.file = { loading: false, progress: 100, ...action.payload };
    },
    [uploadFile.pending]: (state, action) => {
      state.file = { loading: true, progress: 0 };
    },
    [removeFile.fulfilled]: (state, action) => {
      state.file = {
        deleting: false,
        loading: false,
        deleteSuccess: action.payload.success,
      };
    },
    [removeFile.pending]: (state, action) => {
      state.file = { deleting: true, loading: false };
    },
  },
});

export const { updateProgress, selectFiles, resetFiles } = filesSlice.actions;

export default filesSlice.reducer;
